<script setup>
import { ref, computed, watch } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { inject } from 'vue'
import Vidle from 'v-idle'
import { useTheme } from 'vuetify'
import CryptoJS from 'crypto-js'

import BaseLayout from '@/components/base/BaseLayout.vue'
import Header from '@/components/base/Header.vue'
import Menu from '@/components/base/Menu.vue'
import PrimeiroAcessoModal from '@/views/seguranca/PrimeiroAcessoModal.vue'

const chaveSeguranca = inject('chaveSeguranca')

// Rotas onde o menu/header devem ficar ocultos
const hideComponentsRoutes = ['/', '/Login', '/recuperar-senha']

const route = useRoute()
const router = useRouter()

const { global: themeGlobal } = useTheme()
const themeClass = computed(() => `theme-${themeGlobal.current.value}`)

const showLayoutComponents = computed(() => !hideComponentsRoutes.includes(route.path))

function onIdle() {
  localStorage.removeItem('loginNovoSanegeo')
  router.push({ path: '/' }).catch(failure => {
    console.error('Idle logout failed:', failure)
  })
}

const modalPrimeiroAcesso = ref(false)

function verificarPrimeiroAcesso() {
  try {
    const enc = localStorage.getItem('loginNovoSanegeo')
    if (!enc || !chaveSeguranca) return

    const bytes = CryptoJS.AES.decrypt(enc, chaveSeguranca)
    const json = bytes.toString(CryptoJS.enc.Utf8)
    if (!json) return

    const login = JSON.parse(json)
    if (login?.data?.usuario?.primeiroAcesso === true) {
      modalPrimeiroAcesso.value = true
    }
  } catch {
    /**/
  }
}

watch(showLayoutComponents, (autenticado) => {
  if (autenticado) verificarPrimeiroAcesso()
}, { immediate: true })

</script>

<template>
  <!-- 1 único <v-app> para TODA a aplicação -->
  <v-app :class="themeClass">

    <BaseLayout v-if="showLayoutComponents">
      <!-- Header -->
      <template #header>
        <Header />
      </template>

      <!-- Menu lateral -->
      <template #menu>
        <Menu />
      </template>

      <!-- Conteúdo principal -->
      <router-view />

      <!-- Idle watcher fica no footer do layout -->
      <template #footer>
        <Vidle @idle="onIdle" :duration="1200" class="d-none" />
      </template>
    </BaseLayout>

    <!-- Rotas públicas (login, recuperar senha) sem header/menu -->
    <router-view v-else />

    <!-- Modal de primeiro acesso -->
    <PrimeiroAcessoModal v-model="modalPrimeiroAcesso" />

  </v-app>
</template>